export enum PanelFace {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SMALL_PRIMARY = 'small-primary'
}
